import React from 'react';
import { Formik, Form } from 'formik';
import { Send } from '@material-ui/icons';
import Loader from 'react-simple-loading';

import { sendMassMessage } from './services';

import './MassMessage.css';

class MassMessage extends React.Component {
  state = {
    showAlert: false,
    alertMessage: '',
    alertType: '',
    loading: false
  }

  sendMassMessage = (values, actions) => {
    if(values.message) {
      this.setState({loading: true});

      const data = {
        message: values.message
      };

      sendMassMessage(data)
      .then(response => {
        this.setState({
          showAlert: true,
          alertMessage: 'Your fans will be notified!',
          loading: false
        });
        actions.resetForm();
      })
      .catch(err => {
        this.setState({
          showAlert: true,
          alertMessage: 'Something went wrong, please try again later.',
          loading: false
        });
        console.log(err);
        actions.resetForm();
      });
    }
  }

  render () {
    const {
      showAlert,
      alertMessage,
      loading
    } = this.state;
    
    return (
      <>
        <div className="mass-message">
          <p>Send the message to all your fans. This is the perfect way to notify them of your upcoming show!</p>
        </div>
        <div className="mass-message-form">
          <Formik
            initialValues={{ message: '' }}
            onSubmit={this.sendMassMessage}>
            {props => {
              return (
                <Form autoComplete={'off'}>
                  <input
                    name="message"
                    type="text"
                    placeholder="Type something..."
                    onChange={props.handleChange}
                    value={props.values.message}
                  />
                  <button type="submit" className="send-icon">
                    <Send fontSize="inherit" />
                  </button>
                </Form>
              );
            }}
          </Formik>
        </div>
        { loading &&
          <div className="mass-message-loader">
            <Loader size='24px' color={'#000'} />
          </div>
        }
        {showAlert && (
          <div className="mass-message-alert">
            <p>{alertMessage}</p>
          </div>
        )}
      </>
    );
  }
}

export default MassMessage;